import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../../../context/AuthContext';
import GroupField from './GroupField';
import { makeApiCall } from '../../../config';
import { successToaster, ErrorToaster } from '../../../utils/toaster';
import Modal from '../../../components/Modal';



export default function AlertDialog({userInfo}) {
    const [enableModal, setEnableModal] = useState(true);
    const [fields, setFields] = useState({
        username: userInfo?.username,
        email: userInfo?.email,
        mobileNumber: userInfo?.mobileNumber,
        organizationName: userInfo?.organizationName,
        organizationRoll: userInfo?.organizationRoll,
        baseURL: userInfo?.baseURL || [],
        environment: userInfo?.environment || [],
        defaultEnv: userInfo?.defaultEnv,
        defaultURL: userInfo?.defaultURL,
        listOfUrlAndEnv: userInfo?.listOfUrlAndEnv
    });

    const handleDomainUrlChanges = (val, key) => {
        const result = fields?.listOfUrlAndEnv.find((item) => item[key] == val.value);
        if (key === 'environment') {
            setFields({
                ...fields,
                defaultEnv: result.environment,
                defaultURL: result.baseURL
            })
        }
        if (key === 'baseURL') {
            setFields({
                ...fields,
                defaultEnv: result.environment,
                defaultURL: result.baseURL
            })
        }
    }

    const handleSubmit = async(e) =>{
        try {
          e.preventDefault();
          if (fields.username && fields.email && fields.mobileNumber && fields.organizationName && fields.organizationRoll&& userInfo._id) {
            const response = await makeApiCall(`/api/v1/user/edit/${userInfo._id}`, 'put', fields);
            const { message, code } = response;
            successToaster(message);
            if (code) {
              setEnableModal(false);
            }
            return code;
          }else{
            throw new Error("please fill form fields")
          }
        } catch (error) {
          if (error.response && error.response.status === 422) {
            ErrorToaster(error.response.data.message);
          } else {
            ErrorToaster("Something went wrong");
            console.log('error occurred in edit user info ', error);
          }
        }
      }

    return (<>
         <Modal enable={enableModal} title={"Before getting into the dashboard please choose your hostname and environment"} content={<div className="text-sm flex justify-evenly text-gray-500">
            <div className="mb-2">
            <p className=" dark:text-white">
                Environment
              </p>
                <GroupField fields={fields} handleDomainUrlChanges={handleDomainUrlChanges} targetField={"environment"} targetValue={'defaultEnv'} />
            </div>
            <div className="mb-2">
            <p className=" dark:text-white">
                Base URL
              </p>
                <GroupField fields={fields} handleDomainUrlChanges={handleDomainUrlChanges} targetField={"baseURL"} targetValue={'defaultURL'} />
            </div>
        </div>
        } handleCancel={()=> setEnableModal(false)} handleSave={handleSubmit}/>
    </>)
}
